import { Checkbox, Divider, Stack, Typography, styled } from '@mui/material';
import { TreeItem, TreeItemProps, useTreeItem } from '@mui/x-tree-view';
import { TreeNodeWithIndeterminate } from '.';

interface Props {
  node: TreeNodeWithIndeterminate;
  isFirstLevelParent?: boolean;
}

const StyledTreeItem = styled(TreeItem)<
  TreeItemProps & {
    isFirstLevelParent?: boolean;
  }
>`
  margin-left: ${({ isFirstLevelParent, theme }) =>
    isFirstLevelParent ? theme.spacing(1) : theme.spacing(2)};

  .MuiTreeItem-content.Mui-selected {
    background-color: transparent;
  }

  &:hover > .MuiTreeItem-content {
    background-color: transparent;
  }

  .MuiTypography-root {
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    max-width: 100%;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  align-self: center;
`;

export function TreeViewItem(props: Props) {
  const { node, isFirstLevelParent = false } = props;

  const { selected } = useTreeItem(node.id);

  return (
    <>
      <StyledTreeItem
        nodeId={node.id}
        label={
          <Stack direction='row' columnGap={1} padding={1}>
            <StyledCheckbox
              data-testid={node.name}
              checked={selected}
              indeterminate={node.indeterminate}
              tabIndex={-1}
              disableRipple
            />
            <Typography>{node.name}</Typography>
          </Stack>
        }
        isFirstLevelParent={isFirstLevelParent}
      >
        {Array.isArray(node.children)
          ? node.children.map((n) => <TreeViewItem key={n.id} node={n} />)
          : null}
      </StyledTreeItem>
      {isFirstLevelParent && <Divider />}
    </>
  );
}
